window.Proxy = window.Proxy || function () {};

import "./ui/assets/scss/main.scss";

import "dayjs/locale/bs";
import Application from "./Application";

import bsLocale from "./locale/bs.json";
import enLocale from "./locale/en.json";

const rootElement = document.getElementById("app");

export function run(context = "/") {
  if (rootElement) {
    const app = new Application(context, rootElement);
    app.addLocale("bs", bsLocale);
    app.addLocale("en", enLocale);

    return app.start();
  }
}

run();
